<template>
  <div :class="$style.root">
    <h3 :class="['row align-items-center justify-content-between']">
      <div :class="[$style.rootTitle, 'col-auto']">{{ title }}</div>

      <div :class="['col']">
        <div :class="$style.rootLineTitle"></div>
      </div>
    </h3>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TitleLine extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  title
}
</script>

<style lang="scss" module>
.root {
  &--Title {
    color: $color-content;
  }

  &--LineTitle {
    border-bottom: 4px dotted #000;
    // height: 1px;
    // width: 100%;
  }
}
</style>
